import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import DescWithTitleAndIcon from './DescWithTitleAndIcon';

function ListOfDescriptions({ descriptions, maxItemsPerRow }) {
  const fullWidthOfGrid = 12;
  const minColumnWidth = fullWidthOfGrid / maxItemsPerRow;

  const grid = {
    xs: 12,
    sm: 6,
    lg: 4,
    xl: minColumnWidth,
  };

  return (
    <Col xs={12}>
      <Row className="justify-content-center">
        {descriptions && descriptions.map((item) => <DescWithTitleAndIcon key={item._key} item={item} grid={grid} />)}
      </Row>
    </Col>
  );
}

ListOfDescriptions.propTypes = {
  descriptions: PropTypes.arrayOf(
    PropTypes.shape({
      _key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
      image: PropTypes.shape({}).isRequired,
    })
  ).isRequired,
};

export default ListOfDescriptions;
